export default {"src":"/_next/static/media/aelfscan.89005638.svg","height":24,"width":111,"blurWidth":0,"blurHeight":0};